import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'lsq-label',
    template: `
        <label
            [for]="name"
            class="p label"
            [style.marginBottom]="subLabel ? '0.2rem' : '1.2rem'"
            [style.opacity]="disabled ? '0.5' : '1'"
        >
            {{ label }}
        </label>
        <p
            [style.marginBottom]="'1.2rem'"
            *ngIf="subLabel"
            [style.opacity]="disabled ? '0.5' : '1'"
        >
            {{ subLabel }}
        </p>
    `
})
export class LsqLabelComponent {
    @Input() public name: string;
    @Input() public label: string;
    @Input() public subLabel?: string;
    @Input() public disabled = false;
}
